import { ICON__pen } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { LOCAL__ui_set_field_for_generation_layout } from '@/state/ui/image/LOCAL__ui_set_field_for_generation_layout';
import { FIELD__token } from '@shared/dto/generation/graph_invoke/_fields/token/FIELD__token';

interface PROPS {
  field: FIELD__token;
}

export function G_BUTTON__token_edit({ field }: PROPS) {
  const dispatch = use_dispatch();

  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);

  function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    dispatch(LOCAL__ui_set_field_for_generation_layout({ key: 'g_grid2d__token_edit', field }));
  }

  function is_disabled() {
    return g_general__ui_disabled;
  }

  return (
    <UI_PRIMITIVE__button_with_icon_animated
      variant="no-border-on-component"
      {...{ onClick }}
      disabled={is_disabled()}
      size="rect-10-8"
      iconClassNameBase="text-component-item-foreground size-3"
      iconClassNameHovered="!text-bar-foreground"
      Icon={ICON__pen}
    />
  );
}
